/**
 * Copyright Mántum All Rights Reserved.
 */
import { HomeIcon } from '@heroicons/react/24/solid';
import { Fragment } from 'react';

import type { Path } from '@mantum/kanela';

type PropTypes = {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    path?: Path[];
    title?: string;
};

export default function Breadcrumb(props: PropTypes) {
    if (!props.path || props.path?.length === 0) {
        return null;
    }

    // prettier-ignore
    const {
        title = 'Home'
    } = props

    return (
        <div className='flex items-center gap-4 text-base font-semibold text-gray-600'>
            <button data-href='/' type='button' onClick={props.onClick}>
                <HomeIcon className='h-5 w-5' title={title} />
            </button>
            {props.path?.map((path, index) => {
                return (
                    <Fragment key={index}>
                        <div className='cursor-default select-none'>/</div>
                        <button
                            className='font-semibold last:font-normal last:text-primary hover:underline'
                            data-href={path.url}
                            onClick={props.onClick}
                            type='button'
                        >
                            {path.name}
                        </button>
                    </Fragment>
                );
            })}
        </div>
    );
}
